import { DownOutlined, UpOutlined } from "@ant-design/icons"
import { useEffect, useState } from "react"
import { getProgramSelectColumns, getProgramSubjectColumns } from "./model"
import { CustomDynamicTable } from "../../../../../../components/custom/customDynamicTable"

const selectGroundValue: IEditProgramSelectOption = {
    id: 0,
    idx: undefined,
    name: '',
    isRequired: true,
    description: '',
    programSelectOptionItemList: [],
    isEdit: true
}
const subjectGroundValue: IEditProgramSubjectOption = {
    id: 0,
    idx: undefined,
    name: '',
    isRequired: true,
    description: '',
    isEdit: true
}

interface IProps {
    initProgramSelectOptionList: IProgramSelectOption[]
    setProgramSelectOptionList: React.Dispatch<React.SetStateAction<IProgramSelectOption[]>>
    initProgramSubjectOptionList: IProgramSubjectOption[]
    setProgramSubjectOptionList: React.Dispatch<React.SetStateAction<IProgramSubjectOption[]>>
    isDefalutOpen?: boolean
}

const ProgramOptionSetting = ({ initProgramSelectOptionList, setProgramSelectOptionList, initProgramSubjectOptionList, setProgramSubjectOptionList, isDefalutOpen = false }: IProps) => {
    const [isOptonSettingOpen, setIsOptonSettingOpen] = useState<boolean>(isDefalutOpen)
    const [editProgramSelectOptionList, setEditProgramSelectOptionList] = useState<IEditProgramSelectOption[]>(initProgramSelectOptionList?.map(q => ({ ...q, isEdit: false })) ?? [])
    const [editProgramSubjectOptionList, setEditProgramSubjectOptionList] = useState<IEditProgramSubjectOption[]>(initProgramSubjectOptionList?.map(q => ({ ...q, isEdit: false })) ?? [])

    useEffect(() => {
        setProgramSelectOptionList(editProgramSelectOptionList.map(selectOption => {
            const { isEdit, ...rest } = selectOption;
            return { ...rest };
        }));
    }, [editProgramSelectOptionList])

    useEffect(() => {
        setProgramSubjectOptionList(editProgramSubjectOptionList.map(selectOption => {
            const { isEdit, ...rest } = selectOption;
            return { ...rest };
        }));
    }, [editProgramSubjectOptionList])

    return <>
        <div style={{ display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }} onClick={() => setIsOptonSettingOpen(q => !q)}>
            <div style={{ display: 'flex', alignItems: 'end', gap: '16px', fontSize: '20px', fontWeight: 600, paddingBlock: '20px' }}>
                옵션 설정
                <div style={{ color: 'var(--ant-color-text-description)', fontWeight: '400', fontSize: '12px' }}>선택</div>
            </div>
            {isOptonSettingOpen
                ? <DownOutlined />
                : <UpOutlined />}
        </div>
        <div style={{ position: 'relative', height: '1px' }}>
            <div style={{ position: 'absolute', left: '-20px', width: 'calc(100% + 40px)', height: '1px', backgroundColor: 'var(--ant-layout-footer-bg)' }} />
        </div>
        <div style={{ transition: 'max-height 0.3s ease', maxHeight: isOptonSettingOpen ? '100vh' : '0', overflow: 'hidden' }}>
            <div style={{ fontSize: '20px', fontWeight: 600, paddingBlock: '20px' }}>
                선택형 옵션
            </div>
            <CustomDynamicTable groundValue={selectGroundValue} dataList={editProgramSelectOptionList} setDataList={setEditProgramSelectOptionList} getColumns={getProgramSelectColumns} footerText="+ 옵션 추가" />
            <br />
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', fontSize: '20px', fontWeight: 600, paddingBlock: '20px' }}>
                답변형 설정
                <div style={{ color: 'var(--ant-color-text-description)', fontWeight: '400', fontSize: '12px' }}>※ 고객이 직접 작성하는 옵션입니다. (예. 알러지 등)</div>
            </div>
            <CustomDynamicTable groundValue={subjectGroundValue} dataList={editProgramSubjectOptionList} setDataList={setEditProgramSubjectOptionList} getColumns={getProgramSubjectColumns} footerText="+ 옵션 추가" />
        </div>
    </>
}

export { ProgramOptionSetting }